module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_namba-c2b08dcc49e4a53530e938f386952455.jpg";